import './index.scss';

export const NotFoundPage = () => {
    return <div className="not-found">
        <img src="https://c.tenor.com/PIs64JMGjDcAAAAd/sad-cat.gif"/>
        <div>This page seem not exits :( </div>
    </div>
}